var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 5C9.475 5 5 9.36195 5 14.7413C5 19.0462 7.865 22.6969 11.8375 23.9832C12.3375 24.0749 12.5213 23.7738 12.5213 23.5148C12.5213 23.283 12.5125 22.6709 12.5087 21.8592C9.7275 22.4466 9.14 20.5519 9.14 20.5519C8.685 19.4279 8.0275 19.1268 8.0275 19.1268C7.12125 18.5233 8.0975 18.5344 8.0975 18.5344C9.10125 18.6026 9.62875 19.5382 9.62875 19.5382C10.52 21.0277 11.97 20.5977 12.5413 20.3486C12.6312 19.7191 12.8888 19.2891 13.175 19.0462C10.9538 18.8021 8.62 17.9644 8.62 14.232C8.62 13.1688 9.0075 12.3001 9.64875 11.6185C9.53625 11.3732 9.19875 10.3818 9.73625 9.03976C9.73625 9.03976 10.5738 8.7783 12.4863 10.0386C13.2863 9.82169 14.1363 9.71512 14.9862 9.71017C15.8363 9.71512 16.6863 9.82169 17.4862 10.0386C19.3863 8.7783 20.2238 9.03976 20.2238 9.03976C20.7613 10.3818 20.4238 11.3719 20.3238 11.6185C20.9613 12.3001 21.3488 13.1688 21.3488 14.232C21.3488 17.9743 19.0113 18.7984 16.7863 19.0376C17.1363 19.33 17.4613 19.9273 17.4613 20.8393C17.4613 22.143 17.4487 23.1901 17.4487 23.5073C17.4487 23.7626 17.6238 24.0674 18.1363 23.9695C22.1375 22.6932 25 19.04 25 14.7425C25 9.36195 20.5225 5 15 5Z",
    fill: "#874deb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectGithub);
export default __webpack_public_path__ + "static/media/project-github.b97ffbcb20848d0dad77e7cbb3acfe4f.svg";
export { ForwardRef as ReactComponent };